import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'inline-msg',
  templateUrl: './inline-msg.component.html',
  styleUrls: ['./inline-msg.component.scss'],
})


export class InlineMsgComponent implements OnChanges {
  @Input() inlineMsg: {value: string; css: string};

  public currentValue;

  onDone() {
    if (this.currentValue) {
      this.currentValue.value = undefined; // Erases parent message automatically.
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes.inlineMsg.currentValue) {
        this.currentValue = changes.inlineMsg.currentValue;
      }
    } catch (err) {
      console.error(err);
    }
  }
}
